$( window ).ready(function() {

	// these functions help the gravity forms (for estimators) do advanced calculations

	// 1. AA FORM
	/*
		Key Rules

		1.	If Total Disposable Capital > Max Disposable Capital (£1716): Then NOT eligible.
		2.	Else if claiming Benefits: Eligible, regardless of any other calculations.
		3.	Else if NOT claiming Benefits:
			a.	If Weekly Disposable Income  < lowest value (£105) on Contribution Scale: Eligible for Full Legal Aid
			b.	Else If Weekly Disposable Income  > highest value (£245) on Contribution Scale: NOT Eligible
			c.	Else this makes them Partially Eligible, see below ** currently broken

		Partially Eligible 

		1.	The user is informed of the “Full Contribution” they must make (from their point on the Contribution Scale)
		2.	PLUS,
			a.	If it’s a Criminal Case, the alternative option for “Diagnostic Contribution” is explained.
			b.	If it’s a Civil Case, the alternative option for “General Contribution” is explained.
			
			(note that Diagnostic and General use the same scale, but apply different terminology when being explained)
	*/


	// we need to detect pretty much any change in the calculator, so we do so.
    $( '.calculator-form-aa input, .calculator-form-aa select' ).change(function () 
    {
    	var disposable = 0;
 		var last_on_scale = 0;
 		var last_on_diagnostic_scale = 0;
 		var contribution_scale_value = "TBC";
 		var diagnostic_scale_value = "TBC";

    	// first get a disposable weekly income from the form and turn it into a number
		$('.disposable_income_weekly input[type="text"]').each(function () 
		{
		    disposable = $(this).val();
		    disposable = Number(disposable.replace(/[^0-9.-]+/g,""));

		    // a catch all for negative values
		    if (disposable <= 0)
		    {
		    	disposable = 1;
		    }

		});

		// next change the selected item on the contribution_scale select box to match disposable
 		$('.contribution_scale option').each(function () 
 		{
 			now_on_scale = $(this).html();
 			now_on_scale_val = $(this).val();

 			if ( disposable > 0 && disposable >= last_on_scale && disposable <= now_on_scale  )
 			{
 				$(this).parent().val(now_on_scale_val);
 				contribution_scale_value = now_on_scale_val;
 			}
 			//console.log(last_on_scale + " - " + now_on_scale + " (" + disposable + ")");
 			last_on_scale = now_on_scale;
		   	
		});   

 		// last, change the value of spans "contribution_scale_output" to match the value of contribution_scale select value

 		if (contribution_scale_value != "TBC")
 		{
			$('.contribution_scale_output').each(function () {
			    $(this).html(contribution_scale_value);
			});

		}

		// next change the selected item on the diagnostic_scale select box to match disposable
 		$('.diagnostic_scale option').each(function () 
 		{
 			now_on_scale = $(this).html();
 			now_on_scale_val = $(this).val();

 			if ( disposable > 0 && disposable >= last_on_diagnostic_scale && disposable <= now_on_scale  )
 			{
 				$(this).parent().val(now_on_scale_val);
 				diagnostic_scale_value = now_on_scale_val;
 			}
 			//console.log(last_on_scale + " - " + now_on_scale + " (" + disposable + ")");
 			last_on_diagnostic_scale = now_on_scale;
		   	
		});   

 		// last, change the value of spans "diagnostic_scale_output" to match the value of diagnostic_scale select value

 		if (diagnostic_scale_value != "TBC")
 		{
			$('.diagnostic_scale_output').each(function () {
			    $(this).html(diagnostic_scale_value);
			});

		}

    });


	// 2. CIVIL FORM

    $( '.calculator-form-civil .total_disposable_income_calc input, .calculator-form-civil .total_disposable_capital').change(function () 
    {

    	var disposable = 0;
    	var civil_disposable_float = 0;
 		var disposable_income_scale_values = [];
 		var disposable_income_scale_labels = [];
 		var disposable_capital_scale_values = [];
 		var contribution = 0;
 		var currBandSum = 0;
 		var beyond_threshold = false;

 		var contribution_monthly = 0;
 		var contribution_schedule = 0;
 		var contribution_capital = 0;

    	// all this just to make negative values into 0 in disposable income

    	// 1. first get a disposable weekly income from the form and turn it into a number
		$('.calculator-form-civil .total_disposable_income_calc input').each(function () 
		{
		    disposable = $(this).val();
		    if (disposable && disposable.length > 0)
		    {
		    	civil_disposable_float = Number(disposable.toString().replace(/[^0-9.-]+/g,""));
		    }
		    // a catch all for negative values
		    if (civil_disposable_float <= 0)
		    {
		    	civil_disposable_float = 0;
		    }

		});

		// update the form to show disposable income (0 if negative)
		$('.calculator-form-civil .total_disposable_income_final input').each(function() 
		{
		    // a catch all for negative values
		    if (civil_disposable_float <= 0)
		    {
		    	disposable = "£0.00";
		    }
			$(this).val(disposable);
		});

		// 3. get an array of disposable income contribution bands (DICB) from the gravity form scale (disposable_income_scale)
 		$('.calculator-form-civil .disposable_income_scale option').each(function() 
 		{
 			disposable_income_scale_values.push($(this).val());	
 			disposable_income_scale_labels.push($(this).html());	

		}); 

 		// 4. go through each DICB
 		// note that this is a sliding scale
 		// scale is set in Gravity Forms
 		if (disposable_income_scale_labels.length > 0)
 		{

 			// if above the upper limit, they will not qualify on income
 			if (disposable_income_scale_labels[disposable_income_scale_labels.length - 1] < civil_disposable_float)
 			{
 				beyond_threshold = true;
 				//console.log("Disposable income £" +  civil_disposable_float + " exceeds the threshold of £" +  disposable_income_scale_labels[disposable_income_scale_labels.length - 1]);
 			}
 			else
 			{
 				var disposable_now = civil_disposable_float;
 				/*	
					go through each band, and
					1. work out the upper and low limits.
					2. use the assigned percentage value to calculate a contribution required within this band
					3. move down to the next band with what is remaining of their income
 				*/
				for (var i = disposable_income_scale_labels.length - 1; i >= 0; i--) 
				{
					//console.log ("\nDICB: Upper Limit = £"  + disposable_income_scale_labels[i] + " at " + disposable_income_scale_values[i] + "%");									
					
					var one_down = (i > 0) ? (i - 1) : 0;
					var one_down_value = disposable_income_scale_labels[one_down];

					if (disposable_now > one_down_value) 
					{	
						
						/*console.log ("DICB Match:");
						console.log ("Total Disposable Income = £" + civil_disposable_float);
						console.log ("Remaining Disposable Income = £" + disposable_now);
						console.log ("Upper Limit on this Band = £" +  disposable_income_scale_labels[i]);
						console.log ("Lower Limit on this Band = £" +  one_down_value);*/

						currBandSum = disposable_now - one_down_value;

						//console.log ("Current Band Contribution Calculation (£" + disposable_now  + "-£" +  one_down_value + ") = £" + currBandSum + " at " + disposable_income_scale_values[i]  +"%");
						
						disposable_now -= currBandSum;
						contribution_now = currBandSum * (disposable_income_scale_values[i]/100);
						contribution = contribution + (contribution_now);
						
						//console.log ("Current Band Contribution = £" + contribution_now);
						//console.log ("Rolling Total Contribution Required = £" + contribution);

					}

				}
			}

		}


		if (contribution > 0)
		{
			var last_on_scale = 0;
			//we need an array of contribution bands
	 		$('.calculator-form-civil .instalment_payment_scale option').each(function () 
	 		{
	 			now_on_scale = $(this).html();
	 			now_on_scale_val = $(this).val();

	 			//console.log(contribution + " " + now_on_scale + " " + now_on_scale_val)

	 			if ( contribution >= now_on_scale  )
	 			{
	 				contribution_schedule = now_on_scale_val;
	 				contribution_monthly = roundPoint((contribution / contribution_schedule), 2);

					$('.contribution-monthly-schedule').each(function () {
					    $(this).html(contribution_schedule);
					});
					$('.contribution-monthly-payment').each(function () {
					    $(this).html(currencyFormat(contribution_monthly));
					});
					$('.contribution-overall-payment').each(function () {
					    $(this).html( roundPoint(contribution, 2) );
					});


	 			}
	 			//console.log(last_on_scale + " - " + now_on_scale + " (" + disposable + ")");

			}); 

		}

		$('.calculator-form-civil .contribution input').each( function () 
		{
			$(this).val(contribution);
		});

		// set capital figure as a div
		$('.calculator-form-civil .capital_threshold_measurement_lower input').each(function () 
		{
		    contribution_capital = $(this).val();
			$('.contribution-capital-payment').each(function () {
			    $(this).html(contribution_capital);
			});

		});

		// note that the capital calculations are carried out on Gravity forms
		// if User's Capital > Max Disposable Capital, they do not qualify
		// If User's Capital < Min Disposable Capital, they do not qualify
		// Else is it's User's Capital - Minimum Disposable Capital

    });

	// 3. CHILDREN FORM

	/*
		The children's calculator rules

		1. If on benefits, 
			THEN full legal aid is available

		ELSE

		2. If NOT on benefits 
			AND total capital >  maximum disposable capital
			(regardless of any income calculations)
			THEN no legal aid is available (due to capital)

		3. If NOT on benefits 
			AND total capital <  maximum disposable capital
			AND weekly disposable income > maximum weekly disposable income (max / 52)
			THEN no legal aid is available (due to income)

		4. If NOT on benefits 
			AND weekly disposable income < maximum weekly disposable income (max / 52)
			AND weekly disposable income < minimum weekly disposable income (min / 52)
			AND total capital <  maximum disposable capital
			THEN full legal aid is available

		5. If NOT on benefits 
			AND weekly disposable income < maximum weekly disposable income (max / 52)
			AND weekly disposable income > minimum weekly disposable income (min / 52)
			AND total capital <  maximum disposable capital
			THEN contributed legal aid is available
			This is the complicated element, as there is a matrix of outcomes depending on the case type and disposable income
			//  see notes below for calculations

	*/

    $( '.calculator-form-children .children-weekly-disposable-income input, .calculator-form-children .children-total-disposable-capital input, .calculator-form-children .children-type-of-case select, .calculator-form-children .children-on-benefits input').change(function () 
    {

    	var weekly_income = 0;
    	var weekly_allowances = 0;
    	var weekly_disposable_income = 0;
    	var weekly_expenditure = 0;
    	var total_capital = 0;
    	var total_disposable_capital = 0;
    	var on_benefits = 0;
    	var min_disposable_income = 0;
    	var disposable_income_weekly_less_minimum = 0;

    	var type_of_case = false;
    	var contribution_required = 0;
    	var contribution = 0;
    	var contribution_error = false;


    	// step 1: if on benefits, set income, allowances, expenses, disposable income calc to 0
    		// calculations and resets are not needed, as gravity form hides these fields instead
    		// so all we do is set a toggle var in local JS variables

		$('.calculator-form-children .children-on-benefits input:checked').each(function () 
		{
		    on_benefits = ($(this).val());
		});

		// step 1a: get a value from Gravity for the type of case (used for contributions)

		$('.calculator-form-children .children-type-of-case option:selected').each(function () 
		{
		    type_of_case = ($(this).val());
		});


		// step 2: re-assign the variables from Gravity form values if not on_benefits
		//console.log("benefits:" + on_benefits);
		if (on_benefits == 0 || on_benefits == "No")
		{
	    	// a.income
			$('.calculator-form-children .children-weekly-income input').each(function () 
			{
			    tmp = $(this).val();
			    if (tmp && tmp.length > 0)
			    {
			    	weekly_income = Number(tmp.toString().replace(/[^0-9.-]+/g,""));
			    }

			});
	    	// b.allowances
			$('.calculator-form-children .children-weekly-allowances input').each(function () 
			{
			    tmp = $(this).val();
			    if (tmp && tmp.length > 0)
			    {
			    	weekly_allowances = Number(tmp.toString().replace(/[^0-9.-]+/g,""));
			    }

			});
	    	// c. expenses
			$('.calculator-form-children .children-weekly-expenditure input').each(function () 
			{
			    tmp = $(this).val();
			    if (tmp && tmp.length > 0)
			    {
			    	weekly_expenditure = Number(tmp.toString().replace(/[^0-9.-]+/g,""));
			    }

			});
	    	// d. disposable income
			$('.calculator-form-children .children-weekly-disposable-income input').each(function () 
			{
			    tmp = $(this).val();
			    //console.log("tmp" + tmp);
			    if (tmp && tmp.length > 0)
			    {
			    	weekly_disposable_income = Number(tmp.toString().replace(/[^0-9.-]+/g,""));

			    	// value cannot be a negative 
			    	if (weekly_disposable_income < 0)
			    	{
			    		weekly_disposable_income = 0;
			    	}
			    	else
			    	{
			    		weekly_disposable_income = Math.floor(weekly_disposable_income); // always rounded down, see the rules
			    	}

			    }
			});

			//console.log(on_benefits, weekly_income, weekly_allowances, weekly_expenditure, weekly_disposable_income);

		}


    	// Step 3:  now see if they need to make a contribution
    	// if the Gravity Form calculation for disposable_income_weekly_less_minimum is more than 0, then they will
		$('.calculator-form-children .disposable_income_weekly_less_minimum input').each(function () 
		{
		    tmp = $(this).val();
		    if (tmp && tmp.length > 0)
		    {
		    	disposable_income_weekly_less_minimum = Number(tmp.toString().replace(/[^0-9.-]+/g,""));
		    }
		});

	    if (disposable_income_weekly_less_minimum > 0)
	    {
	    	contribution_required = 1;
	    }

	    // send a boolean back to Gravity, whether they need a contribution
 		$('.calculator-form-children .children-contribution-is-required input').each(function () 
 		{
 			$(this).val(contribution_required);
		}); 


 		// Step 4: calculate the actual contribution.
 			// this is complicated because we've had to extract a multi column table into a JS Object
 			// which is a much more cumbersome way to read data
 			// for "group" e.g. group1, read a group of Case Types
 			// in all likelihood any changes to the band limits will simply have to be triplicated below (i.e. once in each group)


 		if (contribution_required > 0 && type_of_case != false && type_of_case != "")
 		{
 			// a. set up the 3 groups
 			var group1 = 
 			{
 				types: ['S98', 'S99', 'S160'], // an array of all case types that fall into this group
 				payment_weeks: 4, // the payment period in weeks for this group
 				income_bands:
 				{
 					0:
 					{
 						min_income: 68, // the band is from here up inclusive
 						max_income: 100, // the band is from here down inclusive
 						contribution_pct: 20, // percentage of contribution for those in this band
 					},
 					1:
 					{
 						min_income: 100, 
 						max_income: 130,
 						contribution_pct: 40,
 					},
 					2:
 					{
 						min_income: 130, 
 						max_income: 160,
 						contribution_pct: 55,
 					},
 					3:
 					{
 						min_income: 160, 
 						max_income: 222,
 						contribution_pct: 70,
 					},
 				}
 			};

 			var group2 = 
 			{
 				types: ['S48', 'S101', 'S110', 'S154', 'S161', 'S162', 'S166'], // an array of all case types that fall into this group
 				payment_weeks: 12, // the payment period in weeks for this group
 				income_bands:
 				{
 					0:
 					{
 						min_income: 68, // the band is from here up inclusive
 						max_income: 100, // the band is from here down inclusive
 						contribution_pct: 15, // percentage of contribution for those in this band
 					},
 					1:
 					{
 						min_income: 100, 
 						max_income: 130,
 						contribution_pct: 25,
 					},
 					2:
 					{
 						min_income: 130, 
 						max_income: 160,
 						contribution_pct: 45,
 					},
 					3:
 					{
 						min_income: 160, 
 						max_income: 222,
 						contribution_pct: 67,
 					},
 				}
 			};

 			var group3 = 
 			{
 				types: ['S132', 'S142', 'S152', 'S163', 'S164', 'S165', 'S167'], // an array of all case types that fall into this group
 				payment_weeks: 24, // the payment period in weeks for this group
 				income_bands:
 				{
 					0:
 					{
 						min_income: 68, // the band is from here up inclusive
 						max_income: 100, // the band is from here down inclusive
 						contribution_pct: 10, // percentage of contribution for those in this band
 					},
 					1:
 					{
 						min_income: 100, 
 						max_income: 130,
 						contribution_pct: 20,
 					},
 					2:
 					{
 						min_income: 130, 
 						max_income: 160,
 						contribution_pct: 30,
 					},
 					3:
 					{
 						min_income: 160, 
 						max_income: 222,
 						contribution_pct: 40,
 					},
 				}
 			};

 			// b. loop through the groups and find which group the chosen type_of_case belongs to
 				// this is ugly, but effective
 			var use_this_group = false;
 			test = findMeInArray(group1['types'], type_of_case);
 			if (test == true)
 			{
 				use_this_group = group1;
 			}
 			else
 			{
	 			test = findMeInArray(group2['types'], type_of_case);
	 			if (test == true)
	 			{
	 				use_this_group = group2;
	 			}
	 			else
	 			{
		 			test = findMeInArray(group3['types'], type_of_case);
		 			if (test == true)
		 			{
		 				use_this_group = group3;
		 			}	
	 			} 				
 			}

 			// c. if a group is found, loop through each band in the group, 
 				// while keeping an increasing tally of the contribution required at each band
 			if (use_this_group)
 			{
 				var income_bands = use_this_group['income_bands'];
 				var payment_weeks = use_this_group['payment_weeks']; // set the payment weeks
 				var tallied_contribution = 0; // the actual final contribution to be made
 				var our_steps = 1;

				for(var prop in income_bands) 
				{
					if( income_bands.hasOwnProperty(prop) ) 
					{
						prop2 = (income_bands[prop]);
						//console.log(weekly_disposable_income, prop2['min_income']);
						// only loop if thir income is within or over this band
						if (weekly_disposable_income > prop2['min_income'])
						{
							// detect a maximum contribution amount for this band. 
								// if they have more income than the upper limit, it's the full amount (max - min)
								// otherwise its their income - min
							var amount_within_band = weekly_disposable_income - prop2['min_income'];
							if (weekly_disposable_income > prop2['max_income'])
							{
								amount_within_band = prop2['max_income'] - prop2['min_income'];
							}

							// now the actual contribution within this band 
								//calculation: (amount_within_band * percentage for this band) * number of weeks for this band
							var contributable_within_band = roundPoint( ( amount_within_band * (prop2['contribution_pct'] / 100) ) * payment_weeks, 2); 
							
							tallied_contribution += contributable_within_band;
							//console.log("Step " + our_steps + " ~ " + " Overall weekly disposable income: £" + weekly_disposable_income +  ", Amount to be 'taxed' within band: £" + amount_within_band + ", Final contribution within band: £" + contributable_within_band + ", Tallied Contribution leaving band: £" + tallied_contribution );
						}

					 }
					 our_steps++;
				}
				
				// d. only proceed if contribution is greater than 0
				if (tallied_contribution && tallied_contribution > 0)
				{
					var final_contribution_output = currencyFormat(tallied_contribution);

					// update the children-contribution-overall-payment span on the rlevant Gravity div
					$('.children-contribution-overall-payment').each(function () {
					    $(this).html( final_contribution_output );
					});

					
				}
				else
				{
					contribution_error = true;
				}

 			}
			else
			{
				contribution_error = true;
			}
 		}

    });

	// Children's Step 2A: Update the visible weekly disposable input field on Gravity
		// moved to the end of these function to stop JS getting in an orderly twist

    $( '.calculator-form-children .children-weekly-disposable-income input').change(function () 
    {
    	var public_disposable_1 = "£ 0.00"; 
	    tmp_1 = $(this).val();
	    if (tmp_1 && tmp_1.length > 0)
	    {
	    	weekly_disposable_income_1 = Number(tmp_1.toString().replace(/[^0-9.-]+/g,""));
	    }

    	if (weekly_disposable_income_1 > 0)
    	{
    		/*console.log("1 " + weekly_disposable_income_1);
    		var raw = Math.floor(weekly_disposable_income_1); // why was this here?
    		console.log("2 " +  raw);
    		raw = raw.toFixed(2);
    		console.log("3 " + raw);*/

    		public_disposable_1 = "£ " + numberWithCommas(weekly_disposable_income_1.toFixed(2));
    	}

 		$('.calculator-form-children .children-weekly-disposable-income-visible input').each(function () 
 		{
 			$(this).val(public_disposable_1);
		}); 

    });


	// helper functions across all calculators

	function findMeInArray(theArr, theVal)
	{
		var found = theArr.indexOf(theVal);
		if (found > -1)
		{
			return true;
		}
		return false;
	}


	function roundPoint (_n,d) {
		return (Math.round (_n*Math.pow(10,d)))/Math.pow(10,d);
	}

	function numberWithCommas(x) {
	    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

	function currencyFormat(num) {
	  return '£' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
	}


});